import { ReactNode } from 'react'
import KpiCell from 'workflow/common/kpiCell'

import {
  incrementalOpen,
  incrementalOpenMachineExcluded,
  openUplift,
  openUpliftMachineExcluded,
} from '../constants'

type Props = {
  reports: [string, string | number | null][]
  children: ReactNode
}

const PerformanceReport = ({ reports, children }: Props) => {
  return (
    <>
      {reports.map(([key, value]) => {
        let formattedValue = value?.toLocaleString('en') || 'NA'

        const isUpliftValue = key.toLowerCase().includes('uplift')
        if (isUpliftValue && formattedValue !== 'NA') {
          formattedValue = `${formattedValue}%`
        }
        if (key === openUpliftMachineExcluded) {
          key = openUplift
        }
        if (key === incrementalOpenMachineExcluded) {
          key = incrementalOpen
        }
        return (
          <KpiCell
            key={key}
            title={key}
            value={formattedValue}
            valueClassName="text-maroon-400"
          />
        )
      })}
      {children}
    </>
  )
}

export default PerformanceReport
